<template>
    <div class="buildingCardContainer" v-bind:data-scroll-into-view="scrollIntoViewProcessed">
        <div class="clearfix buildingCardContainer-row">
            <h2 class="buildingCardContainer-row-column buildingCardContainer-title">
                {{buildingName}}
            </h2>
            <NotificationWidget class="buildingCardContainer-row-column"
                                v-bind:buildingId="buildingProcessedId"
            ></NotificationWidget>
            <div class="buildingCardContainer-row-column buildingCardContainer-row-column-last buildingCardContainer-badge">
                <Users
                        :buildingRoleName="buildingRole"
                        :users = "users"
                        :buildingId="buildingProcessedId"
                        @refetchUsers = "fetchUsers(buildingProcessedId)"
                ></Users>
            </div>
        </div>
        <div class="buildingCardContainer-body">

            <BuildingSummaryCard
                    v-if="buildingProcessedId"
                    v-bind:buildingId="buildingProcessedId"
                    v-bind:buildingCardRef="$refs"
                    v-bind:eventHub="eventHub">
            </BuildingSummaryCard>

            <div class="flexContainer">
                <div class="flexContainer-item-sub">
                    <div class="flexContainer-item" v-if="showBuildingTestFormCard">
                        <BuildingTestFormCard
                                @reFetch="fetchBuildingTests(buildingProcessedId)"
                                @reFetchScheduledTests="fetchScheduledTests(buildingProcessedId)"
                                @showFormCard="setFormCard"
                                v-bind:building_id="buildingProcessedId"
                                v-bind:report_type="undefined"
                                v-bind:lead_time="afssInformation.data.lead_time ? afssInformation.data.lead_time : undefined"
                                v-bind:dead_line="afssInformation.data.dead_line ? afssInformation.data.dead_line : undefined"
                                v-bind:building_time_zone="timeZone"
                                v-bind:exist_dead="!!afssInformation.data.dead_line">
                            <template slot="title">
                                <h5 class="card-title buildingCard-title">
                                            <span class="iconBeforeTitle">
                                                <i class="fas fa-sliders-h"></i>
                                            </span>
                                    AFSS &amp; Testing Preferences
                                    <ToolTip>
                                        <sup class="superScript">
                                            <i class="fas fa-info-circle"
                                               data-toggle="tooltip"
                                               data-placement="top"
                                               data-html="true"
                                               title=""
                                               data-original-title='EMIoT system will generate automatic test based on the deadline'
                                            ></i>
                                        </sup>
                                    </ToolTip>
                                </h5>
                            </template>
                        </BuildingTestFormCard>
                    </div>
                    <div class="flexContainer-item" v-else>
                        <AfssPreferences
                                @reFetch="fetchBuildingTests(buildingProcessedId)"
                                @showFormCard = 'setFormCard'
                                @reFetchScheduledTests="fetchScheduledTests(buildingProcessedId)"
                                v-bind:buildingId="buildingProcessedId"
                                v-bind:lead_time="afssInformation.data.lead_time ? afssInformation.data.lead_time : undefined"
                                v-bind:dead_line="afssInformation.data.dead_line ? afssInformation.data.dead_line : undefined"
                                v-bind:afssInformation="afssInformation"
                                v-bind:buildingTimeZone="timeZone"
                        >
                            <template slot="title">
                                <h5 class="card-title buildingCard-title">
                                        <span class="iconBeforeTitle">
                                            <i class="fas fa-sliders-h"></i>
                                         </span>
                                    AFSS &amp; Testing Preferences
                                    <ToolTip>
                                        <sup class="superScript">
                                            <i class="fas fa-info-circle"
                                               data-toggle="tooltip"
                                               data-placement="top"
                                               data-html="true"
                                               title=""
                                               data-original-title='EMIoT system will generate automatic test based on the deadline'
                                            ></i>
                                        </sup>
                                    </ToolTip>
                                </h5>
                            </template>
                        </AfssPreferences>
                    </div>

                    <RequiresSitePermissions v-bind:cssClass="'flexContainer-item'" v-bind:required-permissions="['READ']" v-bind:site-id="buildingProcessedId">
                        <Schedule
                                @reFetch="fetchBuildingTests(buildingProcessedId)"
                                @reFetchScheduledTests="fetchScheduledTests(buildingProcessedId)"
                                v-bind:key="`TestSchedule${buildingProcessedId}`"
                                v-bind:buildingId="buildingProcessedId"
                                v-bind:scheduleTest="scheduleTest"
                                v-bind:comingScheduleTest="comingScheduleTest"
                                v-bind:buildingTimeZone="timeZone"
                        ></Schedule>
                    </RequiresSitePermissions>
                </div>

                <RequiresSitePermissions v-bind:cssClass="'flexContainer-item'" v-bind:required-permissions="['READ']" v-bind:site-id="buildingProcessedId">
                    <ReportsCard v-bind:buildingId="buildingProcessedId"></ReportsCard>
                </RequiresSitePermissions>

            </div>

            <template
                    v-if="showCreateBuildingCard">
            <BuildingDetailCard
                    class="buildingCard-fullWidth"
                    v-bind:key="`BuildingDetailCard${buildingProcessedId}`"
                    v-bind:buildingId="buildingProcessedId"
                    v-bind:buildingLatitude="buildingLatitude"
                    v-bind:buildingLongitude="buildingLongitude"
                    v-bind:buildingStrataNo="buildingStrataNo"
                    v-bind:buildingName="buildingName"
                    v-bind:buildingAddress="buildingAddress"
                    v-bind:buildingStatusColor="buildingStatusColor"
                    @showCreateBuildingCard = "showCreateBuildingCard=false"

            >
                <template slot="title">
                    <h5 class="card-title buildingCard-title">
                    <span class="iconBeforeTitle">
                        <i class="far fa-building"></i>
                    </span>
                        Building Details
                        <ToolTip>
                            <sup class="superScript">
                                <i class="fas fa-info-circle"
                                   data-toggle="tooltip"
                                   data-placement="top"
                                   data-html="true"
                                   title=""
                                   data-original-title='You can manage your building details here'
                                ></i>
                            </sup>
                        </ToolTip>
                    </h5>
                </template>
            </BuildingDetailCard>
            </template>
            <template  v-else>
                <CreateBuildingCard
                        v-bind:key="`CreateBuildingCard${buildingProcessedId}`"
                        v-bind:buildingId="buildingProcessedId"
                        v-bind:buildingLatitude="buildingLatitude"
                        v-bind:buildingLongitude="buildingLongitude"
                        v-bind:buildingStrataNo="buildingStrataNo"
                        v-bind:buildingName="buildingName"
                        v-bind:buildingAddress="buildingAddress"
                        v-bind:buildingStatusColor="buildingStatusColor"
                        v-bind:buildingSuburb="buildingSuburb"
                        v-bind:building_post_code="building_post_code"
                        v-bind:buildingState="buildingState"
                        v-bind:buildingStreetAddress="buildingStreetAddress"
                        @close="showCreateBuildingCard=true"
                >
                    <template slot="title">
                        <h5 class="card-title buildingCard-title">
                    <span class="iconBeforeTitle">
                        <i class="far fa-building"></i>
                    </span>
                            Building Details
                            <ToolTip>
                                <sup class="superScript">
                                    <i class="fas fa-info-circle"
                                       data-toggle="tooltip"
                                       data-placement="top"
                                       data-html="true"
                                       title=""
                                       data-original-title='You can manage your building details here'
                                    ></i>
                                </sup>
                            </ToolTip>
                        </h5>
                    </template>
                </CreateBuildingCard>
            </template>

            <div class="clearfix"></div>

            <div ref="deviceList">
                <DeviceListCard ref="device-list-el"
                                v-if="buildingProcessedId"
                                @reFetchScheduledTests="fetchScheduledTests(buildingProcessedId)"
                                v-bind:deviceModels="deviceModels"
                                v-bind:buildingId="buildingProcessedId"
                                v-bind:pageTitle="'Device List'"
                                v-bind:eventHub="eventHub"
                />
            </div>

            <RequiresSitePermissions v-bind:required-permissions="['READ']" v-bind:site-id="buildingProcessedId">
                <FloorPlanCard ref="floor-plan-list-el"
                        v-if="buildingProcessedId"
                        v-bind:buildingId="buildingProcessedId"
                        v-bind:pageTitle="'Floor Plans'"
                ></FloorPlanCard>
            </RequiresSitePermissions>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import RequiresSitePermissions from '@/components/RequiresSitePermissions.vue'
import AfssPreferences from '@/components/building-management/AfssPreferences.vue';
import Schedule from '@/components/building-management/Schedule.vue';
import ReportsCard from '@/components/building-management/ReportsCard.vue';
import BuildingDetailCard from '@/components/building-management/BuildingDetailCard.vue';
import BuildingTestFormCard from '@/components/building-management/BuildingTestFormCard.vue';
import DeviceListCard from '@/components/building-management/DeviceListCard.vue';
import Users from '@/components/building-management/Users.vue';
import Tools from '@/app-model/tools.js';
import User from '@/app-model/user.js';
import ToolTip from '@/components/tool-tip/ToolTip.vue';
import NotificationWidget from '@/components/building-management/NotificationWidget.vue';
import CreateBuildingCard from '@/components/building-management/CreateBuildingCard.vue';
import FloorPlanCard from '@/components/building-management/FixtureFloorPlanCard.vue';
import BuildingSummaryCard from '@/components/building-management/BuildingSummaryCard.vue';
import DeviceModel from '@/app-model/deviceModel.js';

export default {
    props: {
      buildingId: Number,
      buildingLatitude: String|Number,
      buildingLongitude: String|Number,
      buildingStrataNo: String,
      buildingName: String,
      buildingRole: String,
      buildingAddress: String,
      buildingStatusColor: String,
      timeZone:String,
      scrollIntoView: String,
      buildingSuburb:String,
      building_post_code:[Number,String],
      buildingState:String,
      buildingStreetAddress: String
    },
    data () {
      return {
        notifications: {
          invisible: true,
          selectedValue: [],
          list: []
        },
        scheduleTest:{
          data : [],
          meta : {}
        },
        afssInformation: {
          data : [],
          meta : {}
        },

        comingScheduleTest: {
          data : [],
          meta : {},
        },
        showCreateBuildingCard:true,
        showBuildingTestFormCard:true,
        building_test_id:'',
        users:[],
        deviceModels: {},
        timerScrollIntoView: undefined,
        eventHub: new Vue()
      };
    },
    components: {
      RequiresSitePermissions,
      AfssPreferences,
      DeviceListCard,
      Schedule,
      ReportsCard,
      BuildingDetailCard,
      BuildingTestFormCard,
      Users,
      ToolTip,
      NotificationWidget,
      CreateBuildingCard,
      FloorPlanCard,
      BuildingSummaryCard
    },
    mounted () {
      this.fetchDeviceModels(this.buildingId);
      this.fetchBuildingTests(this.buildingId);
      this.fetchScheduledTests(this.buildingId);
      this.fetchUsers(this.buildingId);

      jQuery($('[data-toggle="tooltip"]').tooltip())
    },
    computed: {
      building: function() {
        return this.$store.getters.building({buildingId: this.buildingProcessedId});
      },
      tools: function() {
        return new Tools;
      },
      UserModel: function() {
        return new User;
      },
      deviceModelTools: function () {
        return new DeviceModel;
      },
      scheduleTestList: function() {
        let {data = []} = this.comingScheduleTest;
        return data;
      },
      scheduleTestMeta: function() {
        let {meta = {}} = this.comingScheduleTest;
        return meta;
      },
      scrollIntoViewProcessed: function () {
        let top = this;
        if(this.scrollIntoView !== undefined) {
          this.timerScrollIntoView = setTimeout(function(){
            if(top.$refs[top.scrollIntoView] !== undefined) {
              top.$refs[top.scrollIntoView].$el.scrollIntoView({
                behavior: 'instant'
              });
            }

            top.$emit('update:scrollIntoView', undefined);
          }, 50);
        }
        return this.scrollIntoView;
      },
      buildingProcessedId: function () {
        return this.buildingId;
      }
    },
    beforeDestroy () {
      this.removeTimer();
    },
    methods: {
      removeTimer: function (buildingId) {
        clearTimeout(this.timerScrollIntoView);
      },
      setFormCard:function (value) {
        this.showBuildingTestFormCard = value
        this.$emit('reFetch');
      },

      fetchUsers(buildingId){
        this.UserModel.fetchBuildingUsers({buildingId, store: this.$store}).then(response => {
          if(response.status === 200 && buildingId === this.buildingId) {
            this.$set(this.users, 'data', response.data.data);
          }
        });
      },
      //Schedule Tests fetching starts from here
      fetchScheduledTests(buildingId) {
        this.$store.dispatch(
          'apiResult',
          {
            method: 'GET',
            path: `api/user-buildings/${buildingId}/schedule-test`,
            path_template: `/api/user-buildings/{building_id}/schedule-test`,
            building_id: buildingId
          }
        ).then(response => {
          if(response.status === 200 && buildingId === this.buildingId) {
            this.$set(this.comingScheduleTest, 'data', response.data.data);
            this.$set(this.comingScheduleTest, 'meta', response.data.meta);

          }
        })
      },

      fetchDeviceModels(buildingId){
        return this.deviceModelTools.allByBuilding({store: this.$store}, buildingId).then(response => {
          switch (response.status) {
            case 200:
              for (let i = 0; i < response.data.data.length; i++) {
                Vue.set(this.deviceModels, response.data.data[i]['id'], Object.assign({}, response.data.data[i]));
              }
              break;
          }
          return response;
        });
      },

      fetchBuildingTests (buildingId) {
        this.$store.dispatch(
          'apiResult',
          {
            method: 'GET',
            path: `api/user-buildings/${buildingId}/afss`,
            path_template: `/api/user-buildings/{building_id}/afss`,
            building_id: buildingId
          }
        ).then(response => {
          if(response.status === 200 && buildingId === this.buildingId) {
            this.$set(this.afssInformation, 'data', response.data.data);
            this.$set(this.afssInformation, 'meta', response.data.meta);
            if(response.status === 200) {
              this.showBuildingTestFormCard = !this.afssInformation.data.dead_line &&
                  this.$store.getters.hasSitePermissions({siteId: buildingId, requiredPermissions: ['WRITE']});
            }
          }
        });
      },
    }
  }

</script>
<style lang="scss" scoped>
    @import "@/../sass/_grid.scss";
    @import "@/../sass/_building_card.scss";
</style>